import React, { useMemo } from "react";
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
} from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { chartOptions, stringToHslColor } from "./helper";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const PracticeChart = ({ summary, selectedPractices, onTogglePractice }) => {
  const practiceOptions = useMemo(
    () => Array.from(new Set(summary.map((s) => s.practice_name))),
    [summary]
  );

  // aggregate counts per practice and filter by selectedPractices
  const chartAgg = useMemo(() => {
    const map = new Map();
    summary.forEach((item) => {
      if (!selectedPractices.includes(item.practice_name)) return;
      const current = map.get(item.practice_name) || 0;
      map.set(item.practice_name, current + item.count);
    });
    return Array.from(map.entries()).map(([name, total]) => ({
      practice_name: name,
      total_count: total,
    }));
  }, [summary, selectedPractices]);

  const chartData = useMemo(() => {
    const labels = chartAgg.map((d) => d.practice_name);
    const data = chartAgg.map((d) => d.total_count);

    const bgColors = labels.map((name) => stringToHslColor(name, 65, 65));
    const bdColors = labels.map((name) => stringToHslColor(name, 65, 40));

    return {
      labels,
      datasets: [
        {
          label: "Dictation Count",
          data,
          backgroundColor: bgColors,
          borderColor: bdColors,
          borderWidth: 1.5,
          borderRadius: 6,
          barThickness: "flex",
          maxBarThickness: 60,
        },
      ],
    };
  }, [chartAgg]);

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        mb={2}
        alignItems="center"
      >
        <Typography fontSize={14} fontWeight={600}>
          Dictation Count by Practice
        </Typography>
        <FormGroup row>
          {practiceOptions.map((name) => (
            <FormControlLabel
              key={name}
              control={
                <Checkbox
                  size="small"
                  checked={selectedPractices.includes(name)}
                  onChange={() => onTogglePractice(name)}
                />
              }
              label={name}
            />
          ))}
        </FormGroup>
      </Box>

      <Box sx={{ width: "100%", height: 380, px: 2 }}>
        <Bar data={chartData} options={chartOptions} />
      </Box>
    </Paper>
  );
};

export default PracticeChart;
